<template>
  <div>
    <div v-for="(i, index) in list" :key="index" class="section">
      <div class="title">{{ i.section }}</div>
      <div v-for="j in i.list" :key="j[0]">
        <div class="question" v-html="j[0]"></div>
        <div class="answer" v-html="j[1]"></div>
      </div>
    </div>
  </div>
</template>

<script>
import en from '@/assets/locales/faq/en'
import id from '@/assets/locales/faq/id'

export default {
  data() {
    return {
      list: { en, id }[this.$i18n.locale],
    }
  },
}
</script>

<style lang="stylus" scoped>
.section {
  margin-bottom: 10px;
  padding: 16px;
  &:first-child {
    margin-top: 30px;
  }
}

.title {
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid color-primary;
  padding-bottom: 12px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

.question {
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 16px;
  letter-spacing: 0.3px;
}

.answer {
  font-size: 14px;
  padding-bottom: 40px;
  letter-spacing: 0.1px;
  line-height: 18px;
}
</style>
